import PropTypes from "prop-types";
import React from "react";

import ModalShell from "../../../global/ModalShell";
import ResponseModals from "../../Common/Modals/components/ResponseModals";
import useModalHandler from "../../Common/Modals/hooks/useModalHandler";
import { setModalHandlerInstance } from "../../Common/Modals/hooks/useModalSingleton";

import useProviderDetail from "./hooks/useProviderDetail";
import ProviderDetailContent from "./ProviderDetailContent";

export default function ProviderDetailModal({ providerDetail, open, setOpen }) {
  const handlers = useModalHandler();
  setModalHandlerInstance(handlers);
  const detailState = useProviderDetail(providerDetail, open);

  return (
    <>
      <ModalShell
        open={open}
        setOpen={setOpen}
        title={null}
        fullScreen={false}
        fullWidth={true}
        customWidth="lg"
      >
        <ProviderDetailContent {...detailState} />
      </ModalShell>
      <ResponseModals {...handlers} />
    </>
  );
}

ProviderDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  providerDetail: PropTypes.object,
  setOpen: PropTypes.func.isRequired,
};
